import React from 'react';
// Components
import AdminCreateUserForm from './components/AdminCreateUserForm/AdminCreateUserForm';

const CreateProfile = (): JSX.Element => {
  return <AdminCreateUserForm />;
};

export default CreateProfile;
